









































import { Component, Vue } from 'vue-property-decorator';

import {
  Language, i18n, recipes,
} from '../data';

@Component
export default class RecipeBrowser extends Vue {
  private allRecipes = recipes;

  private recipes = this.allRecipes;

  private i18n = i18n;

  private language: Language = 'ENUS';

  private show = 0;

  searchItems(query: string): void[] {
    if (query.length < 1) {
      this.recipes = this.allRecipes;
      return [];
    }
    const regex = new RegExp(query, 'i');
    this.recipes = this.allRecipes.filter((recipe) => recipe.Name.match(regex)
      || recipe.IconPath.match(regex)
      || this.i18n.ZHCN[recipe.Name].match(regex)
      || this.i18n.ENUS[recipe.Name].match(regex)
      || this.i18n.FRFR[recipe.Name].match(regex));

    return [];
  }
}
